import {
  marketingInitialValues,
  musicProductDigitalCopyrights,
} from 'components/organisms/forms/music-product-digital/MusicProductDigitalForm';
import { RELEASE_TYPE } from 'services/music-product-digital/types/enums';
import { IMusicProductDigitalForm } from 'services/music-product-digital/types/form';
import { IMusicProductDigitalResponse } from 'services/music-product-digital/types/query';
import { settlementInfoQueryToForm } from './settlementInfoQueryToForm';
import { convertTracksToAlbumsForm } from './tracksToAlbums';

export const convertMusicProductDigitalQueryToForm = (
  musicProductDigitalQuery: IMusicProductDigitalResponse
): IMusicProductDigitalForm => {
  const { id, ...musicProductDigitalForm } = {
    ...musicProductDigitalQuery,
    releaseDate: musicProductDigitalQuery.releaseDate
      ? new Date(musicProductDigitalQuery.releaseDate)
          .toISOString()
          .slice(0, 10)
      : '',
    tracks: convertTracksToAlbumsForm(musicProductDigitalQuery.tracks),
    artists: musicProductDigitalQuery.artists.map(artist => ({
      id: artist.artistId,
      role: artist.artistRole,
      nickname: artist.nickname,
    })),
    cLine: musicProductDigitalQuery.cLine ?? musicProductDigitalCopyrights,
    pLine: musicProductDigitalQuery.pLine ?? musicProductDigitalCopyrights,
    settlementInfo: settlementInfoQueryToForm(
      musicProductDigitalQuery.settlementInfo
    ),
    releaseType: musicProductDigitalQuery.releaseType ?? RELEASE_TYPE.unknown,
    genre:
      musicProductDigitalQuery.genre !== null &&
      musicProductDigitalQuery.genre.id !== -1
        ? {
            id: musicProductDigitalQuery.genre.id,
            name: musicProductDigitalQuery.genre.name,
          }
        : { id: -1, name: '' },
    deliveryFilter: { onlyDefaultProviders: true },
    marketing: marketingInitialValues,
    videoId: musicProductDigitalQuery.video?.videoId ?? '',
  };
  return musicProductDigitalForm;
};
